import {Game} from '@/core/game.js';

import {stategame} from '@/states/game.js';

let resources = 0;

if (stategame.getstate().tree === true) {

    resources += 1;
}

if (stategame.getstate().temple === true) {

    resources += 1;
}

if (stategame.getstate().mountain === true) {

    resources += 1;
}

const container = document.getElementById('container');
const start = document.getElementById('start');

start.addEventListener('pointerdown', () => {

    container.style.display = 'none';

    const game = new Game();

    game.start();
});
